const showLoginOverlay = () => {
    //eslint-disable-next-line
    $.showLoginOverlay();
};

export default {
    showLoginOverlay,
};
